import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[mweDefaultImage]' })
export class DefaultImageDirective {
  private elementRef = inject(ElementRef);

  @Input() mweDefaultImage: string;
  isFirstError = true;

  @HostListener('error')
  onError(): void {
    if (!this.isFirstError) {
      // only handle first error to avoid error-handling-loop
      return;
    }

    this.isFirstError = false;
    this.elementRef.nativeElement.src = this.mweDefaultImage;
  }
}
